import { TextField, styled } from '@mui/material';

const TextFieldStyled = styled(TextField)(() => ({
  '&.input-hidden': {
    display: 'none'
  }
}));

export default TextFieldStyled;
